@if (loading) {
  <div class="flex flex-col gap-2">
    <div class="h-14 animate-pulse rounded-lg bg-slate-50"></div>
    <div class="h-14 animate-pulse rounded-lg bg-slate-50"></div>
    <div class="h-14 animate-pulse rounded-lg bg-slate-50"></div>
  </div>
} @else if (calls.length) {
  <div class="flex flex-col gap-2">
    @for (call of calls; track call.id) {
      <div class="rounded-lg border border-slate-200 bg-slate-50 p-3 text-sm">
        <div class="flex items-center justify-between gap-2">
          <div class="flex items-center gap-1.5">
            <app-icon
              class="!text-[18px]"
              [class.text-emerald-500]="call.call_type === 'in'"
              [class.text-sky-500]="call.call_type === 'out'"
            >
              {{ call.call_type === 'in' ? 'call_received' : 'call_made' }}
            </app-icon>
            <span class="font-semibold text-slate-800">{{ call.phone || '-' }}</span>
          </div>
          <div class="flex shrink-0 items-center gap-1">
            <span class="text-xs text-slate-400">{{ formatCallDate(call) }}</span>
            <button
              type="button"
              class="flex h-6 w-6 items-center justify-center rounded text-slate-400 hover:bg-slate-100 hover:text-slate-600"
              [attr.aria-label]="'board_v3_calls_actions' | translate"
              [cdkMenuTriggerFor]="callActionsMenu"
            >
              <app-icon class="!h-4 !w-4 !text-[16px] !leading-4">more_vert</app-icon>
            </button>
          </div>
        </div>

        <ng-template #callActionsMenu>
          <div cdkMenu class="min-w-40 rounded-xl border border-gray-100 bg-white p-1.5 shadow-lg">
            <button
              type="button"
              cdkMenuItem
              class="flex w-full items-center gap-2 rounded-lg px-3 py-2 text-left text-sm text-red-600 hover:bg-red-50"
              (click)="onDeleteClick(call)"
            >
              <app-icon class="!h-4 !w-4 !text-[16px] !leading-4 text-red-500">delete</app-icon>
              {{ 'delete' | translate }}
            </button>
          </div>
        </ng-template>
        <div class="mt-1 flex flex-wrap items-center gap-3 text-xs text-slate-500">
          <span>{{ call.disposition || '-' }}</span>
          <span>{{ formatDuration(call.duration_ms) }}</span>
          @if (call.x_data?.employee_fio) {
            <span>{{ call.x_data.employee_fio }}</span>
          }
        </div>
        @if (call.recording_url) {
          <audio class="mt-2 w-full" controls [src]="call.recording_url"></audio>
        }
        @if (call.transcription || call.transcript_utterances?.length) {
          <div class="mt-2 flex items-start justify-between gap-2">
            @if (call.transcription) {
              <details class="min-w-0 flex-1">
                <summary class="cursor-pointer text-xs font-medium text-orange-600">
                  {{ 'board_v3_calls_transcription' | translate }}
                </summary>
                <p class="m-0 mt-1 whitespace-pre-wrap text-xs leading-5 text-slate-600">{{ call.transcription }}</p>
              </details>
            }
            @if (call.transcript_utterances?.length) {
              <button
                type="button"
                class="flex shrink-0 items-center gap-1.5 rounded-lg! bg-white px-2.5 py-1.5 text-xs font-semibold text-orange-600 shadow-sm transition hover:bg-orange-50"
                (click)="openTranscript(call)"
              >
                <app-icon class="!h-4 !w-4 !text-[16px] !leading-none">forum</app-icon>
                {{ 'board_v3_calls_transcript_dialog' | translate }}
              </button>
            }
          </div>
        }
      </div>
    }
  </div>
} @else {
  <div class="flex min-h-24 flex-col items-center justify-center rounded-lg bg-slate-50 px-4 py-6 text-center">
    <app-icon class="mb-1 !text-[24px] text-slate-300">call</app-icon>
    <p class="m-0 text-sm text-slate-400">{{ 'board_v3_calls_empty' | translate }}</p>
  </div>
}
